// extracted by mini-css-extract-plugin
module.exports = {"container":"CivilWork-module--container--1F6jv","subtitle":"CivilWork-module--subtitle--1M7bj","details":"CivilWork-module--details--2Wgt_"};